module.exports = __webpack_public_path__ + "media/categories/4015-793b1dde.svg";